/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Location = /** @class */function () {
  function Location() {}
  return Location;
}();
export { Location };